import { gamesService, usersService } from ".";
import { createPersistentStore } from "./store";
export const reload = createPersistentStore('reload', false);
export class ReloadService {
    constructor(httpService) {
        this.httpService = httpService;
    }
    async saveReload() {
        const game = await gamesService.getGameInCourseForTheCurrentManager();
        const user = await usersService.getMe();
        await this.httpService.post(`addReloadLog`, { gameId: game.id, userId: user.id });
    }
}
